import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Wrench, Sparkles, MessageCircle, Lock } from "lucide-react";
import { STORE, waLink, openAssistant } from "@/lib/store";

export const Header = () => {
  const [open, setOpen] = useState(false);

  const NavLinks = ({ onClick }) => (
    <>
      <Link data-testid="nav-link-repairs" to="/riparazioni" onClick={onClick} className="text-sm font-medium text-neutral-600 transition-colors hover:text-black">Riparazioni</Link>
      <Link data-testid="nav-link-usato" to="/usato" onClick={onClick} className="text-sm font-medium text-neutral-600 transition-colors hover:text-black">Usato</Link>
      <Link data-testid="nav-link-contact" to="/contatti" onClick={onClick} className="text-sm font-medium text-neutral-600 transition-colors hover:text-black">Contatti</Link>
    </>
  );

  const askAi = () => { openAssistant(); setOpen(false); };

  return (
    <header className="sticky top-0 z-40 border-b border-neutral-200 bg-white/90 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center gap-4 px-4 sm:px-6">
        <Link data-testid="iphix-header-logo" to="/" className="flex shrink-0 items-center gap-2">
          <img src="/iphix-logo.png" alt="iPhix Scafati" className="h-11 w-auto" />
          <span className="hidden text-[10px] font-mono uppercase tracking-widest text-neutral-400 sm:inline">{STORE.city}</span>
        </Link>

        <div className="ml-auto hidden items-center gap-6 md:flex">
          <NavLinks />
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <button data-testid="nav-ai-ask-btn" onClick={askAi} className="inline-flex items-center gap-2 rounded-full bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-md shadow-blue-500/20 transition-all hover:scale-[1.03] hover:bg-blue-700">
            <Sparkles className="h-4 w-4" /> Chiedi prezzi all'AI
          </button>
          <a data-testid="nav-whatsapp" href={waLink("Ciao iPhix!")} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-sm font-medium text-white hover:bg-[#20ba59]">
            <MessageCircle className="h-4 w-4" /> WhatsApp
          </a>
          <Link data-testid="nav-login" to="/login" className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-neutral-200 text-neutral-500 transition-colors hover:border-black hover:text-black" title="Area riservata">
            <Lock className="h-4 w-4" />
          </Link>
        </div>

        <button data-testid="mobile-menu-btn" onClick={() => setOpen((v) => !v)} className="ml-auto inline-flex h-10 w-10 items-center justify-center rounded-lg border border-neutral-200 text-neutral-700 md:hidden">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-neutral-200 bg-white px-4 py-4 md:hidden">
          <div className="flex flex-col gap-4">
            <NavLinks onClick={() => setOpen(false)} />
            <button data-testid="nav-ai-ask-btn-mobile" onClick={askAi} className="inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white">
              <Sparkles className="h-4 w-4" /> Chiedi prezzi all'AI
            </button>
            <a href={waLink("Ciao iPhix!")} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-4 py-2.5 text-sm font-medium text-white">
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
            <Link to="/login" onClick={() => setOpen(false)} className="inline-flex items-center gap-2 text-sm text-neutral-600"><Lock className="h-4 w-4" /> Area riservata</Link>
          </div>
        </div>
      )}
    </header>
  );
};
